export function chunk<T>(arr: T[], chunkSize: number): T[][] {
  return [...new Array(Math.ceil(arr.length / chunkSize)).keys()]
    .map((i) => i * chunkSize)
    .map((i) => arr.slice(i, Math.min(arr.length, i + chunkSize)));
}
